module.exports = __webpack_public_path__ + "img/4S-shop-b.9df67e3a.png";